{
  "/": {
    "title": "サハラマラソン完走記録｜250km・7日間の砂漠レース全記録",
    "description": "サハラマラソン（Marathon des Sables／250キロの砂漠ウルトラマラソン）を2025年に完走したエンジニアのリアルな記録。総費用100万円超の内訳、12ヶ月の準備、装備30点以上、全6ステージの体験レポートを公開中。2026年第40回記念大会の情報も掲載。",
    "sitemap": {
      "lastmod": "2026-04-03",
      "changefreq": "weekly",
      "priority": "1.0"
    }
  },
  "/profile": {
    "title": "井上周（INOUE Amane）｜サハラマラソン2025完走者・エンジニア",
    "description": "井上周（INOUE Amane）。群馬出身のソフトウェアエンジニア。2025年サハラマラソン（Marathon des Sables）250kmを完走。年齢・職業・挑戦の背景・競技歴などプロフィール詳細。",
    "sitemap": {
      "lastmod": "2026-04-03",
      "changefreq": "monthly",
      "priority": "0.8"
    }
  },
  "/project": {
    "title": "サハラマラソン完走レポート｜250kmを7日間で走り切った全6ステージの記録",
    "description": "サハラマラソン（Marathon des Sables）2025を完走したリアルレポート。全6ステージの体験、82.2kmのロングステージ、砂漠での7日間の実態を、未経験から1年で走り切った当事者が記録しています。",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-04-03",
      "changefreq": "monthly",
      "priority": "0.8"
    }
  },
  "/race": {
    "title": "大会実績",
    "description": "井上周のマラソン・トレイルランニング大会実績。S-Mountain、Island Trail AWAJI、IZU TRAIL Journey、東京マラソン2025の結果一覧。",
    "sitemap": {
      "lastmod": "2026-03-16",
      "changefreq": "monthly",
      "priority": "0.7"
    }
  },
  "/race/2026": {
    "title": "サハラマラソン 2026｜費用100万円〜の全費目・日程・準備を完走者が解説",
    "description": "2026年4月開催のサハラマラソン（Marathon des Sables）第40回記念大会の情報まとめ。2025年完走者が日程、参加費用（総額約100万円〜）、必要な装備、準備の流れを解説します。",
    "sitemap": {
      "lastmod": "2026-03-26",
      "changefreq": "weekly",
      "priority": "0.9"
    }
  },
  "/cost": {
    "title": "サハラマラソンの費用は総額いくら？2025完走者が実費ベースで内訳を公開",
    "description": "サハラマラソン（Marathon des Sables）の費用を、2025年完走者の実支出ベースで解説。参加費・渡航費・練習費・装備費の内訳から総額100〜130万円の目安まで、費用を抑えるポイントも含めて紹介します。",
    "sitemap": {
      "lastmod": "2026-07-18",
      "changefreq": "monthly",
      "priority": "0.9"
    }
  },
  "/equipments": {
    "title": "サハラマラソン装備・持ち物リスト｜250km完走の全ギア公開",
    "description": "サハラマラソン2025で実際に使った持ち物・装備をまとめたギアリスト。全30点以上をバックパック・シューズ・寝袋など重量・価格で徹底比較。総重量7kg台に収めた軽量化ノウハウと必携装備チェックリスト付き。",
    "sitemap": {
      "lastmod": "2026-03-16",
      "changefreq": "monthly",
      "priority": "0.9"
    }
  },
  "/photos": {
    "title": "サハラマラソン フォトギャラリー｜砂漠レースの景色24枚",
    "description": "サハラマラソン2025（Marathon des Sables）のリアルな写真・動画ギャラリー。砂漠のコース、ビバーク、完走シーンなど24枚。サハラ砂漠マラソンの実際の景色を公開。",
    "sitemap": {
      "lastmod": "2026-04-08",
      "changefreq": "weekly",
      "priority": "0.8"
    }
  },
  "/equipment-guide": {
    "title": "サハラマラソン装備ガイド｜完走者が教える選び方の3原則",
    "description": "サハラマラソン完走者が実体験から導いた装備選びのガイド。軽量性・信頼性・シンプルさの3原則で、シューズ・バックパック・寝袋のおすすめと軽量化テクニックを解説。",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-03-26",
      "changefreq": "monthly",
      "priority": "0.8"
    }
  },
  "/kilimanjaro": {
    "title": "キリマンジャロ登頂記｜5,895mで身体が先に降参した話",
    "description": "2026年8月、アフリカ大陸最高峰キリマンジャロ（5,895m）にマラングルート4泊5日で登頂。サハラマラソン250km完走者が、高山病、深夜0時のサミットアタック、そして「サハラよりきつい瞬間」を記録した登頂記と写真。",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-08-24",
      "changefreq": "monthly",
      "priority": "0.9"
    }
  },
  "/en/kilimanjaro": {
    "title": "Climbing Kilimanjaro — five days on the Marangu route to 5,895 m",
    "description": "August 2026: five days on the Marangu route to Uhuru Peak (5,895 m), the highest point in Africa. A Marathon des Sables finisher on altitude sickness, the midnight summit attempt, and how the mountain compares with 250 km across the Sahara.",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-09-09"
    }
  },
  "/kilimanjaro/route": {
    "title": "キリマンジャロ マラングルート4泊5日の行程｜登頂までの全日程",
    "description": "アフリカ大陸最高峰キリマンジャロ（5,895m）にマラングルートで登った4泊5日の行程を日程順に記録。各日の区間と標高、深夜0時から始まるサミットアタック、高山病の出方、山小屋泊の実際まで。2026年8月に登頂した一人の記録です。",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-08-24",
      "changefreq": "monthly",
      "priority": "0.8"
    }
  },
  "/en/kilimanjaro/route": {
    "title": "The Marangu route itinerary — five days on Kilimanjaro",
    "description": "A day-by-day record of climbing Kilimanjaro (5,895 m) by the Marangu route: the stages and elevations, the summit attempt that starts at midnight, how altitude sickness showed up, and what hut-based climbing is actually like.",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-09-09"
    }
  },
  "/kilimanjaro/equipments": {
    "title": "キリマンジャロ登山の装備リスト｜持参・現地レンタルと、使わなかったもの",
    "description": "マラングルート4泊5日で実際に使った装備を、持参・現地レンタル・現地購入・ツアー提供に分けて公開。登山口の町モシで借りられるもの、日本から持って行くべきもの、そして推奨されているのに使わなかった装備まで記録しています。",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-08-24",
      "changefreq": "monthly",
      "priority": "0.8"
    }
  },
  "/en/kilimanjaro/equipments": {
    "title": "Kilimanjaro gear list — brought, rented, and never used",
    "description": "The gear actually used over five days on the Marangu route, split into what was brought, rented in Moshi, bought on site and provided by the operator — including the items every packing list recommends that I never used.",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "type": "article",
    "sitemap": {
      "lastmod": "2026-09-09"
    }
  },
  "/kilimanjaro/photos": {
    "title": "キリマンジャロ フォトギャラリー｜熱帯雨林から赤道直下の氷河まで19枚",
    "description": "マラングルート4泊5日で撮影したキリマンジャロの写真19枚。標高1,860mの熱帯雨林、森林限界を越えた低木帯、雲海、キボハットの星空、そして5,895mの山頂に残る氷河まで。",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "sitemap": {
      "lastmod": "2026-08-24",
      "changefreq": "monthly",
      "priority": "0.8"
    }
  },
  "/en/kilimanjaro/photos": {
    "title": "Kilimanjaro photo gallery — rainforest to equatorial glacier",
    "description": "19 photographs from five days on the Marangu route: rainforest at 1,860 m, moorland above the tree line, the sea of cloud, the night sky at Kibo Hut, and the glaciers that survive at 5,895 m.",
    "image": "https://www.saharasabaka.com/images/kilimanjaro/og-kilimanjaro.jpg",
    "sitemap": {
      "lastmod": "2026-09-09"
    }
  },
  "/support": {
    "title": "応援・スポンサー",
    "description": "サハラマラソン挑戦を支えてくださったスポンサー・応援者の皆様への感謝。個人・法人スポンサープランのご案内。",
    "sitemap": {
      "lastmod": "2026-03-16",
      "changefreq": "monthly",
      "priority": "0.5"
    }
  },
  "/contact": {
    "title": "お問い合わせ",
    "description": "サハラサバカへのお問い合わせ。スポンサーシップ、取材依頼、コラボレーションのご相談はこちらから。",
    "sitemap": {
      "lastmod": "2026-03-16",
      "changefreq": "yearly",
      "priority": "0.3"
    }
  },
  "/links": {
    "title": "リンク集",
    "description": "サハラマラソン関連の参考サイト・リンク集。Marathon des Sables公式サイトなど。",
    "sitemap": {
      "lastmod": "2026-03-16",
      "changefreq": "monthly",
      "priority": "0.3"
    }
  },
  "/app": {
    "title": "レース準備アプリ | サハラサバカ",
    "description": "サハラマラソン完走者が作った、マルチデイレース準備アプリ。装備管理・重量計算・準備ロードマップで、あなたの挑戦をサポート。月額¥280。",
    "sitemap": {
      "lastmod": "2026-03-16",
      "changefreq": "monthly",
      "priority": "0.5"
    }
  },
  "/privacy": {
    "title": "プライバシーポリシー",
    "description": "サハラサバカのプライバシーポリシー。Googleアナリティクスによるアクセス解析、Google AdSenseによる広告配信、Amazonアソシエイト・プログラムへの参加、お問い合わせで取得する情報の取り扱いについて記載しています。",
    "sitemap": {
      "lastmod": "2026-08-24",
      "changefreq": "yearly",
      "priority": "0.3"
    }
  },
  "/terms": {
    "title": "利用規約",
    "description": "サハラサバカの利用規約。掲載している文章・写真・動画の著作権、掲載情報の位置づけ、免責事項、外部リンクの取り扱いについて記載しています。",
    "sitemap": {
      "lastmod": "2026-08-24",
      "changefreq": "yearly",
      "priority": "0.3"
    }
  }
}
